import { ApolloClient, InMemoryCache, createHttpLink,split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";
import {createUploadLink} from "apollo-upload-client"


// const httpLink = createHttpLink({
//   // uri: "https://hussleserver.herokuapp.com/graphql",
//   uri: "https://www.atlaskit.app/graphql",
// });

const httpLink = createUploadLink({
  // uri: "https://hussleserver.herokuapp.com/graphql",
  // uri: "https://atlaskit.app/graphql",
  // uri: "https://buzzpay.org/graphql",
  uri :`https://api.atlaskit.app/graphql`
});

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = await localStorage.getItem("token");

  console.log("token",token);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === "OperationDefinition" &&
//       definition.operation === "subscription"
//     );
//   },

//   authLink.concat(httpLink)
// );

export const apolloClient = new ApolloClient({
link:authLink.concat(httpLink),
    cache: new InMemoryCache()
})